export enum UserType {
    User = "USER",
    Manager = "MANAGER",
    Admin = "ADMIN",
    Superuser = "SUPERUSER",
}

const userTypeOrder = {
    [UserType.User]: 0,
    [UserType.Manager]: 1,
    [UserType.Admin]: 2,
    [UserType.Superuser]: 3,
}

export const isAtLeastAdmin = (userType: UserType | null | undefined): boolean => {
    if (userType === null || userType === undefined) {
        return false;
    }
    return userTypeOrder[userType] >= userTypeOrder[UserType.Admin];
}

export const getUserTypeLabel = (userType: UserType | null | undefined): string => {
    switch (userType) {
        case UserType.Admin: return '관리자'
        case UserType.Superuser: return '최고관리자'
        default: return '매니저'
    }
}
